import { render, staticRenderFns } from "./resource-search.vue?vue&type=template&id=0c114212&"
import script from "./resource-search.vue?vue&type=script&lang=ts&"
export * from "./resource-search.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports